var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link",on:{"click":_vm.navigateTo}},[_vm._v(" "+_vm._s(_vm.linkLabel)+" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }